import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import Link from '../components/link';
import {ReactComponent as GmailIcon} from '../svg/gmail-icon.svg';
import {ReactComponent as GithubIcon} from '../svg/github-icon.svg';
import {ReactComponent as LinkedInIcon} from '../svg/linkedin-icon.svg';
import {ReactComponent as TwitterIcon} from '../svg/twitter-icon.svg';

const Contact = () =>
  <div
    css={{
      margin: '0 auto',
      maxWidth: '960px',
      padding: '0 2rem',
    }}
  >
    <Helmet
      title="📬 Contact - Emmanuel Fallancy"
      meta={[
        { name: 'description', content: 'Get in touch with Emmanuel' },
        {
          name: 'keywords',
          content: 'efallancy, Emmanuel Fallancy, emmanuel fallancy'
        },
      ]}
    />
    <header
      css={{
        padding: '0 1rem',
        textAlign: 'center',
        margin: '0 auto',
        maxWidth: '300px'
      }}
    >
      <h1
        css={{
          position: 'relative',
          padding: '1rem 0',
          '&::before': {
            content: '""',
            backgroundColor: 'rgba(37, 206, 209, 0.65)',
            position: 'absolute',
            top: '0',
            left: '0',
            transform: 'skew(-20deg)',
            width: '100%',
            height: '100%',
            zIndex: '-1',
          }
        }}
      >
        Reach out
      </h1>
    </header>
    <main
      css={{
        margin: '0 auto',
        maxWidth: '480px',
      }}
    >
      <p
        css={{
          fontSize: '1.8rem',
          textAlign: 'center',
        }}
      >
        Holla! Feel free to reach out to me.
      </p>
      <div
        css={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
          margin: '4rem 0 1rem',
          width: '100%'
        }}
      >
        <a href="mailto:emmanuel.fallancy@gmail.com?subject=Hi, Emmanuel!">
          <GmailIcon
            height="50px"
            width="70px"
            css={{
              marginRight: '2rem',
              '@media(max-width: 355px)': {
                marginRight: '1rem'
              }
            }}
          />
        </a>
        <Link to="https://github.com/emmafallancy">
          <GithubIcon
            height="50px"
            width="50px"
            css={{
              marginRight: '2rem',
              '@media(max-width: 355px)': {
                marginRight: '1rem'
              }
            }}
          />
        </Link>
        <Link to="https://www.linkedin.com/in/emmanuelfallancy">
          <LinkedInIcon
            height="50px"
            width="50px"
            css={{
              marginRight: '2rem',
              '@media(max-width: 355px)': {
                marginRight: '1rem'
              }
            }}
          />
        </Link>
        <Link to="https://twitter.com/fancyfallancy">
          <TwitterIcon
            height="50px"
            width="60px"
            css={{
              marginRight: '2rem',
              '@media(max-width: 355px)': {
                marginRight: '1rem'
              }
            }}
          />
        </Link>
      </div>
    </main>
  </div>;

export default Contact;


// WEBPACK FOOTER //
// ./src/pages/contact.js